import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { PageSeo } from "@/components/seo/PageSeo";
import { NOINDEX_FOLLOW } from "@/lib/seo/constants";
import { notFoundSeo } from "@/lib/seo/authSeo";

const NotFound = () => {
  const location = useLocation();
  const { language } = useLanguage();
  const seo = notFoundSeo(language);
  const isIt = language === "it";

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <PageSeo title={seo.title} robots={NOINDEX_FOLLOW} />
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">
          {isIt ? "Pagina non trovata" : "Oops! Page not found"}
        </p>
        <Link to="/" className="text-primary underline hover:text-primary/90">
          {isIt ? "Torna alla home" : "Return to Home"}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
